module.exports = __webpack_public_path__ + "img/work2.d081f9b2.png";